// extracted by mini-css-extract-plugin
export const title = "about-module--title--1TRFL";
export const aboutBody = "about-module--aboutBody--qE4Vg";
export const aboutImageSet = "about-module--aboutImageSet--Q9A0C";
export const aboutImage = "about-module--aboutImage--1OC_c";
export const aboutImageCaption = "about-module--aboutImageCaption--1MdhE";
export const aboutText = "about-module--aboutText--1oTKR";